module.exports = __webpack_public_path__ + "static/img/word_video.41d664f.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/word_video.gif
// module id = golP
// module chunks = 1